import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as firebase from 'firebase';
import '../view/css/AFSignupModal.css';
import '../view/css/Home.css';
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
import { v4 as uuidv4 } from 'uuid';
import {AFSignUpModalView} from '../view/AFSignUpModalView';


const theme = createMuiTheme({
    typography: {
        fontFamily: 'Rubik',
        fontSize: 18,
    },
});


export function AFSignupModal() {
    const [open, setOpen] = React.useState(false);
    const [email, setEmail] = React.useState("");
    const [username, setUserName] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [passwordTwo, setPasswordTwo] = React.useState("");
    const [error, setError] = React.useState(false);
    const [email_error, setEmailError] = React.useState(false);
    const [usererror,setUserError] = React.useState(false);


    var firestore = firebase.firestore();
    const db = firestore.collection("Users");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setError(false);
        setUserError(false);
        setEmailError(false);
        setEmail("");
        setUserName("");
        setPassword("");
        setPasswordTwo("");
    };

    const signup = async (e) => {
        var login_possible = true;
        var valid_email = true;
        var user_error = false;
        var vb = firestore.collection("Users");
        var creation_possible = true;
        e.preventDefault();
        if(username == ""){
            setUserError(true);
            user_error = true;
        }
        if (!(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test((email.toLowerCase())))) { 
            valid_email = false; 
            setEmailError(true);
        }
        if (password != passwordTwo) {
            setError(true);
            return
        }
        var creation_possible = true;
        if(valid_email){
        const db = firestore.collection("Users").doc(email.toLowerCase());
        const this_one = await db.get();
        if(this_one.exists){
            creation_possible=false;
            setError(error);
        }
    }
        if(creation_possible && valid_email && !user_error){
        vb.doc(email.toLowerCase()).set({

            username: username,
            email: email,
            id: email.toLowerCase(),
            password: password,
            students:[],
            interests: [],
            social_medias:[],
            events: [],
            photos:[],
            events:[],
            profile_pic: "",
            description: "",
            subscriptions: [email.toLowerCase()],
            type: "Affiliate",
            events: [],
          
    
        });
   
   let allPromises = await firebase.auth().createUserWithEmailAndPassword(email.toLowerCase(), password).then((u) => {
    }).then((u) => { console.log(u + "email.toLowerCase")})
    .catch((error) => {
        console.log(error);
        setError(true);
        console.log("THERE IS INDEED AN ERROR");
        login_possible = false;
       
    })
    login();
    }
    }



    const login = (e) => {
      

        firebase.auth().signInWithEmailAndPassword(email, password).then((u) => {
        }).catch((error) => {
            console.log(error);
        });
    }
    const inputUser = (e) => {
        setUserName(e.target.value)
    }
    const inputEmail = (e) => {

        setEmail(e.target.value)
    }

    const inputPassword = (e) => {
        setPassword(e.target.value)
    }

    const inputPasswordTwo = (e) => {
        setPasswordTwo(e.target.value)
    }

    return (
       <AFSignUpModalView handleClickOpen={handleClickOpen} theme={theme} open={open} handleClose={handleClose} error={error} email_error={email_error}  usererror={usererror} inputEmail={inputEmail} email={email} inputUser={inputUser} username={username} inputPassword={inputPassword} password={password} inputPasswordTwo={inputPasswordTwo } passwordTwo={passwordTwo} signup={signup}/>
    );
}
